import { useTranslation } from 'react-i18next';
import { Loader, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';
import { useGetSubsidiaryCompaniesByParent } from 'src/hooks/companies/get-subsidiary-companies.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

import { CompanyProfileInfo } from './components/company-profile-info';
import { HeaderContainer } from './company-profile.styles';
import CompanyActionButtons from './components/company-expanded-list/company-action-buttons.component';
import CompanyExpandedList from './components/company-expanded-list/company-expanded-list.component';

const CompanyProfile = () => {
  const { t } = useTranslation();
  const currentCompanyId = useGetCurrentCompanyId();
  const { company, loading } = useGetCurrentCompany();
  const { companies, loading: subsidiaryLoading } =
    useGetSubsidiaryCompaniesByParent(currentCompanyId);

  if (loading || subsidiaryLoading) {
    return <Loader />;
  }

  return (
    <div>
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>{`${t(
          `settings:company.labels.parentCompany`
        )}: ${company.name}`}</Typography>
        <CompanyActionButtons company={company} />
      </HeaderContainer>
      <CompanyProfileInfo company={company} />
      {companies.map((item: any) => (
        <CompanyExpandedList key={item._id} company={item} />
      ))}
    </div>
  );
};

export default CompanyProfile;
